import * as Mod1 from "./discourse/components/post-signature";
import * as Mod2 from "./discourse/connectors/user-custom-preferences/signature-preferences.gjs";
import * as Mod3 from "./discourse/initializers/extend-for-signatures";
import * as Mod4 from "./discourse/pre-initializers/signatures-plugin-api";
const compatModules = {
  "discourse/components/post-signature": Mod1,
  "discourse/connectors/user-custom-preferences/signature-preferences": Mod2,
  "discourse/initializers/extend-for-signatures": Mod3,
  "discourse/pre-initializers/signatures-plugin-api": Mod4,
};
export { compatModules };
export default compatModules;
